import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { EmpresaService } from '../../services/Empresa/Empresa.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-firma',
  templateUrl: './firma.component.html',
  styleUrls: ['./firma.component.scss']
})

export class FirmaComponent implements OnInit {
  public data = this.formBuilder.group({
    sucursal: '',
    nombre: ['', [Validators.required]],
    departamento: ['', [Validators.required]],
    telefonoOficina: '',
    telefonoLlamadas: '',
    extencion: '',
    email: ['', [Validators.required]],
    calle: ['', [Validators.required]],
    numero: ['', [Validators.required]],
    colonia: ['', [Validators.required]],
    codigo_postal: ['', [Validators.required]],
    ciudad: ['', [Validators.required]],
    estado: ['', [Validators.required]],
    whatsapp: ''
  });

  sucursalesIntegradora = ['Tampico', 'Huejutla', 'Guadalajara']
  sucursalesKabik = ['Kabik Norte'];
  sucursalesLetech = ['Huejutla', 'Reynosa', 'Poza Rica', 'Tampico'];
  sucursales: any[] = [];

  empresaID: string;

  constructor(
    private formBuilder: FormBuilder,
    private empresaService: EmpresaService
  ) {
    this.empresaID = String(empresaService.getEmpresaId());
  }

  ngOnInit() {
    this.sucursales = (this.empresaID === '1' ? this.sucursalesKabik : this.empresaID === '5' ? this.sucursalesIntegradora : this.sucursalesLetech);
    if (this.empresaID === '1') {
      this.data.get('sucursal').setValue('Kabik Norte');
      this.data.get('telefonoOficina').setValue('8334543560');
      this.data.get('telefonoLlamadas').setValue('');
      this.data.get('whatsapp').setValue('8338503550');
      this.data.get('calle').setValue('Francisco Villa')
      this.data.get('numero').setValue('209');
      this.data.get('colonia').setValue('Nuevo Progreso');
      this.data.get('codigo_postal').setValue('89318');
      this.data.get('ciudad').setValue('Tampico');
      this.data.get('estado').setValue('Tamaulipas');
    }
  }

  validate(event: any) {
    if (event.value === 'Kabik Norte') {
      this.data.get('telefonoOficina').setValue('8334543560');
      this.data.get('telefonoLlamadas').setValue('');
      this.data.get('whatsapp').setValue('8338503550');
      this.data.get('calle').setValue('Francisco Villa');
      this.data.get('numero').setValue('209');
      this.data.get('colonia').setValue('Nuevo Progreso');
      this.data.get('codigo_postal').setValue('89318');
      this.data.get('ciudad').setValue('Tampico');
      this.data.get('estado').setValue('Tamaulipas');
    } else if (event.value === 'Huejutla') {
      this.data.get('telefonoOficina').setValue('(789) 688 02 76');
      this.data.get('telefonoLlamadas').setValue('');
      this.data.get('calle').setValue('Calle 2');
      this.data.get('numero').setValue('S/N');
      this.data.get('colonia').setValue('Magisterial');
      this.data.get('codigo_postal').setValue('43000');
      this.data.get('ciudad').setValue('Huejutla de Reyes');
      this.data.get('estado').setValue('Hidalgo');
      this.data.get('whatsapp').setValue('8333117725');
    } else if (event.value === 'Reynosa') {
      this.data.get('telefonoOficina').setValue('(899) 128 4763');
      this.data.get('telefonoLlamadas').setValue('');
      this.data.get('calle').setValue('San Rafael');
      this.data.get('numero').setValue('650 Local C');
      this.data.get('colonia').setValue('Prolongación Longoria');
      this.data.get('codigo_postal').setValue('88660');
      this.data.get('ciudad').setValue('Reynosa');
      this.data.get('estado').setValue('Tamaulipas');
      this.data.get('whatsapp').setValue('8333117725');
    } else if (event.value === 'Poza Rica') {
      this.data.get('telefonoOficina').setValue('(782) 822 1705');
      this.data.get('telefonoLlamadas').setValue('');
      this.data.get('calle').setValue('Chihuahua');
      this.data.get('numero').setValue('104 Esq. Querétaro');
      this.data.get('colonia').setValue('México');
      this.data.get('codigo_postal').setValue('93310');
      this.data.get('ciudad').setValue('Poza Rica');
      this.data.get('estado').setValue('Veracruz');
      this.data.get('whatsapp').setValue('8333117725');
    } else if (event.value === 'Tampico') {
      this.data.get('telefonoOficina').setValue('(833) 217 46 42');
      this.data.get('telefonoLlamadas').setValue('');
      this.data.get('calle').setValue('Praderas');
      this.data.get('numero').setValue('106');
      this.data.get('colonia').setValue('Fraccionamiento Puestas del Sol');
      this.data.get('codigo_postal').setValue('89320');
      this.data.get('ciudad').setValue('Tampico');
      this.data.get('estado').setValue('Tamaulipas');
      this.data.get('whatsapp').setValue('8333117725');
    } else if (event.value === 'Guadalajara') {
      this.data.get('telefonoOficina').setValue('(833) 217 46 42');
      this.data.get('telefonoLlamadas').setValue('');
      this.data.get('calle').setValue('Jose Guadalupe Zuno Hernandez');
      this.data.get('numero').setValue('1775');
      this.data.get('colonia').setValue('Americana');
      this.data.get('codigo_postal').setValue('44160');
      this.data.get('ciudad').setValue('Guadalajara');
      this.data.get('estado').setValue('Jalisco');
      this.data.get('whatsapp').setValue('8333117725');
    }
    // if (event.value === 'Kabik Lomas') {
    //   this.data.get('telefono').setValue('');
    //   this.data.get('calle').setValue('Loma Rosa');
    //   this.data.get('numero').setValue('200');
    //   this.data.get('colonia').setValue('Lomas de Rosales');
    //   this.data.get('codigo_postal').setValue('89100');
    //   this.data.get('ciudad').setValue('Tampico');
    //   this.data.get('estado').setValue('Tamaulipas');
    // }
  }

  public submit() {
    if (this.data.invalid) {
      Swal.fire({
        type: 'warning',
        title: 'Advertencia',
        text: 'Faltan campos por completar'
      });
      return;
    }
    const empresa = (this.empresaID === '1' ? '_firma_kabik.html' : this.empresaID === '5' ? '_firma_integradora.html' : '_firma_letech.html')
    let name = this.name(this.data.value.nombre) + empresa;
    let firm = document.querySelector('#firma').outerHTML;
    this.download(name, firm);
  }

  public download(name: string, firm: any) {
    let element = document.createElement('a');
    element.setAttribute('href', 'data:text/html;charset=utf-8,' + firm);
    element.setAttribute('download', name);
    element.click();
  }

  public numeric_input(event) {
    if (event.charCode >= 48 && event.charCode <= 57) {
      return true;
    }
    return false;
  }

  public phone_mask(number: string) {
    return number.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '($1) $2 $3 $4');
  }

  public whatsapp_mask(number: string) {
    return number.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
  }

  public name(name: string) {
    return name.split(' ').join('_').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  public email(email: string) {
    return email.toLowerCase();
  }
}
